import {useRef} from "react";

const useRingtone = (url) => {
    const ringtone = useRef(null);
    if (ringtone.current === null) {
        ringtone.current = new Audio(url);
        ringtone.current.loop=true;
    }
    const playAudio=()=>ringtone.current.play();
    const stopAudio=()=>ringtone.current.pause();
    return [playAudio,stopAudio];
};

export default useRingtone;